import React from "react";
import "./AboutMeStyle.css";
import myPhoto from "../images/my-photo.jpeg";
import {
  FaMedal,
  FaGraduationCap,
  FaMobileAlt,
  FaBrain,
  FaGlobe,
  FaSyncAlt,
  FaMicrophone,
  FaTrophy,
  FaCompass,
} from "react-icons/fa";

const tags = [
  { Icon: FaMedal,         label: "McKinsey & Co. Qimam Fellow '26", color: "#F59E0B" },
  { Icon: FaGraduationCap, label: "BCs (AI) @ Shaqra University",    color: "#60A5FA" },
  { Icon: FaMobileAlt,     label: "iOS Developer",                    color: "#A78BFA" },
  { Icon: FaBrain,         label: "AI Engineer",                      color: "#34D399" },
  { Icon: FaGlobe,         label: "Full-Stack Developer",             color: "#38BDF8" },
  { Icon: FaSyncAlt,       label: "Digital Transformation",           color: "#FB923C" },
  { Icon: FaMicrophone,    label: "Public Speaker",                   color: "#F472B6" },
  { Icon: FaTrophy,        label: "MTE 2× Award Winner",             color: "#FBBF24" },
  { Icon: FaCompass,       label: "Leadership & Project Management",  color: "#4ADE80" },
];

export default function AboutMe({ id }) {
  return (
    <div className="about-container" id={id}>

      {/* ─── LEFT: Photo card ─── */}
      <div className="about-photo-col">
        <div className="about-photo-frame">
          <img src={myPhoto} alt="Ahmed K. Alrasheed" className="about-photo-img" />
          <div className="about-photo-glow" />
          <div className="about-photo-badge">
            <span className="badge-flag">🇸🇦</span>
            <span className="badge-text">Saudi Arabia</span>
          </div>
        </div>

        {/* Qimam pill under photo */}
        <div className="qimam-pill">
          <span className="qimam-dot" />
          <span>QImam Fellow&nbsp;<strong>'26</strong>&nbsp;·&nbsp;2026</span>
        </div>
      </div>

      {/* ─── RIGHT: Content ─── */}
      <div className="about-content-col">

        {/* Header */}
        <div className="about-hello">Hey there 👋</div>
        <h2 className="about-name">Ahmed K. Alrasheed</h2>

        {/* Tags row */}
        <div className="about-tags">
          {tags.map(({ Icon, label, color }, i) => (
            <span key={i} className="about-tag">
              <Icon className="tag-icon" style={{ color }} />
              {label}
            </span>
          ))}
        </div>

        {/* Divider */}
        <div className="about-divider" />

        {/* Bio paragraphs */}
        <div className="about-bio">
          <p>
            I'm a Senior Computer Science student at{" "}
            <span>Shaqra University</span> specializing in{" "}
            <span>AI, Full-Stack Development</span>, and{" "}
            <span>Product Innovation</span>. I merge technical expertise with
            creativity to transform real-world ideas into impactful solutions.
          </p>

          <p>
            Honored to be a <span>McKinsey &amp; Company Qimam Fellow '26</span>{" "}
            — a highly selective leadership program that brings together Saudi
            Arabia's top emerging talent. Graduate of the{" "}
            <span>Apple AI Foundation Camp</span>,{" "}
            <span>Samsung Innovation Campus</span>,{" "}
            <span>KAUST Academy</span>, and{" "}
            <span>Tuwaiq Academy</span>.
          </p>

          <p>
            Led teams to multiple national wins —{" "}
            <span>1st at Imam University Hackathon</span>,{" "}
            <span>1st at Citrus Hackathon</span>,{" "}
            <span>1st at Youth Initiatives Hackathon</span>,{" "}
            <span>2nd at Qualithon &amp; Qurush Entrepreneurship</span>, and{" "}
            <span>1st place three consecutive years</span> in the Scientific
            Forum's Entrepreneurship Track.
          </p>

          <p>
            Represented <span>Saudi Arabia at MTE</span> where "Ingatra" earned{" "}
            <span>two international awards 🏆🏅</span> — the{" "}
            <span>AYIA Gold Medal</span> and the{" "}
            <span>CIIS Grand Prize – Taiwan</span>, competing against
            320+ innovations from 30+ countries. I've built{" "}
            <span>32+ projects</span> across diverse domains — from{" "}
            <span>Agentic AI systems</span> with multi-agent pipelines
            to <span>pure AI/ML</span> models and full-stack products.
          </p>
        </div>

        {/* Stats row */}
        <div className="about-stats">
          <div className="stat-card">
            <div className="stat-num">8+</div>
            <div className="stat-lbl">Hackathon Wins</div>
          </div>
          <div className="stat-divider" />
          <div className="stat-card">
            <div className="stat-num">32+</div>
            <div className="stat-lbl">Projects Built</div>
          </div>
          <div className="stat-divider" />
          <div className="stat-card">
            <div className="stat-num">2×</div>
            <div className="stat-lbl">International Awards</div>
          </div>
          <div className="stat-divider" />
          <div className="stat-card">
            <div className="stat-num">3×</div>
            <div className="stat-lbl">Scientific Forum Champion</div>
          </div>
          <div className="stat-divider" />
          <div className="stat-card">
            <div className="stat-num">+450</div>
            <div className="stat-lbl">Volunteering Hours</div>
          </div>
        </div>

      </div>
    </div>
  );
}
